import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SpacePage from "@/pages/SpacePage";
import AdminPage from "@/pages/AdminPage";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App cs-grain" style={{ minHeight: "100vh" }}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SpacePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#131311",
              border: "1px solid rgba(234,230,223,0.12)",
              color: "#EAE6DF",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "12px",
              letterSpacing: "0.05em",
              borderRadius: "2px",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
